var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2528_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.61801 0C3.65584 0 0.414062 3.23457 0.414062 7.21837C0.414062 10.8203 3.05071 13.81 6.4942 14.3503V9.30752H4.66439V7.21837H6.4942V5.62629C6.4942 3.81809 7.56759 2.82395 9.21729 2.82395C10.0025 2.82395 10.8238 2.96082 10.8238 2.96082V4.7402H9.91607C9.02278 4.7402 8.74183 5.2949 8.74183 5.86403V7.21837H10.7445L10.4204 9.30752H8.74183V14.3503C10.4394 14.0822 11.9852 13.216 13.1001 11.9081C14.2151 10.6003 14.8259 8.93695 14.822 7.21837C14.822 3.23457 11.5802 0 7.61801 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2528_2232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3503,
    height: 14.3503,
    fill: "white",
    transform: "translate(0.414062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.535aa64e158315cde9257688e1a928c8.svg";
export { ForwardRef as ReactComponent };